import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      position: 'static',
      transform: 'none',
      transformOrigin: 'unset',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 500,
      color: colors.black[700],
      marginBottom: theme.spacing(0.75),
      maxWidth: '100%',

      '&.Mui-focused': { color: colors.black[700] },
      '&.Mui-disabled': { color: colors.black[700] },
      '&.Mui-error': { color: colors.black[700] },

      '& .MuiFormLabel-asterisk': { color: colors.red[600] },

      ...theme.applyStyles('dark', {
        color: colors.black[100],
        '&.Mui-focused': { color: colors.black[100] },
        '&.Mui-disabled': { color: colors.black[100] },
        '&.Mui-error': { color: colors.black[100] },
      }),
    }),
  },
};
